import commonService from './common-service';

class ShipingService {
  async getFacDetails(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step1/' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facility details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getCutOffFacility(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step2', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving cut off facility. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitCutOffForm(params) {
    try {
      return await commonService.postToServer('Shipping/Step2', params);
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getSubsequentDetails(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step1/' + params.subseqdropFacId + '/' + params.subseqRxCode, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getCutOffTimes() {
    try {
      const response = await commonService.getFromServer('Shipping/Step2', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getShpDropList(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step3/' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitAuditFac(params) {
    try {
      const response = await commonService.postToServer('Shipping/Step3', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error submitting details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async saveAuditForm(params) {
    try {
      const response = await commonService.postToServer('Shipping/Step3/Save', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error submitting details. Please try after sometime.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async runReportEOD(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step4/' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async packingSlipPublish() {
    try {
      const response = await commonService.getFromServer('Shipping/Step4/Publish', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error publishing. Please contact Administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async publistList(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step5/' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPublishList() {
    try {
      const response = await commonService.getFromServer('Shipping/PublishList', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getNotReadyFacilities(params) {
    try {
      const response = await commonService.getFromServer('Shipping/Step6', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving not ready facility. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getShpngReport(params) {
    try {
      const response = await commonService.getFromServer('Shipping/AuditReport?date=' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving reports. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async postSorterScanRxNumber(params) {
    try {
      const response = await commonService.postToServer('ScanRx/' + params, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving Sorter Scan details. Please contact administrator.');
      }
    } catch (e) {
      const error = new Error(e);
      error.code = e.code;
      error.msg = e.msg;
      throw error;
    }
  }

}

export default new ShipingService();
